import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ImportantInformation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="información-importante" ref={ref} className={cn("bg-primary-900 min-h-[400px] flex items-center justify-center py-10 md:py-9 lg:py-12 px-6 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      <div className="max-w-4xl mx-auto text-center space-y-8">
        <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl text-[rgb(245,241,229)] leading-tight tracking-tight">
          No vendemos online
        </h2>
        
        <p className="font-sans text-lg md:text-xl text-secondary-200 max-w-2xl mx-auto leading-relaxed font-light">
          Apostamos por la cercanía y la exclusividad. Encuentra nuestros aceites únicamente en{" "}
          <Link to="/ForStoresPage" className="text-secondary-100 border-b border-secondary-400/50 hover:border-secondary-100 transition-colors pb-0.5">
            tiendas especializadas
          </Link>{" "}
          o ven a descubrirlos en nuestras{" "}
          <Link to="/HayaTastingPage" className="text-secondary-100 border-b border-secondary-400/50 hover:border-secondary-100 transition-colors pb-0.5">
            catas privadas
          </Link>.
        </p>
      </div>
    </section>;
}